<script setup>
import { ChevronDown } from 'lucide-vue-next'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@codinglabsau/gooey'
import useDynamicIcon from '../../Utils/useDynamicIcon.js'
import { computed, inject, ref } from 'vue'
import RecursiveAccordion from './Components/RecursiveAccordion.vue'
import RecursiveDropdown from './Components/RecursiveDropdown.vue'
import CollapsibleNavItem from './Components/CollapsibleNavItem.vue'
import { useNavigation } from '../../Utils/useNavigation.js'

const name = defineModel('name')

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  viewport: {
    type: Object,
    required: true,
  },
  icon: {
    type: String,
    required: false,
    default: null,
  },
  href: null,
  items: {
    type: Array,
    required: true,
  },
})

const viewport = inject('viewport')
const { getHref } = useNavigation()
const { iconComponent } = useDynamicIcon(() => props.icon)

// State for collapsible component
const isOpen = ref(false)

const computedItems = computed(() => props.items.map((item) => {
  const { iconComponent: itemIcon } = useDynamicIcon(() => item.icon)
  return {
    ...item,
    iconComponent: itemIcon.value
  }
}))
</script>

<template>
  <!-- Mobile Collapsible View -->
  <div v-if="viewport === 'mobile'">
    <CollapsibleNavItem
      :item="{
        name,
        href,
        hasIcon: !!iconComponent,
        iconComponent
      }"
      v-model:isOpen="isOpen"
    >
      <div>
        <RecursiveAccordion :items="computedItems" />
      </div>
    </CollapsibleNavItem>
  </div>

  <!-- Desktop Dropdown View -->
  <DropdownMenu v-else>
    <div v-if="href" class="flex items-center">
      <a
        :href="getHref(href)"
        class="flex whitespace-nowrap font-normal sm:font-medium sm:text-sm items-center hover:underline cursor-pointer"
      >
        <Component v-if="iconComponent" :is="iconComponent" class="size-4 mr-1" />
        {{ name }}
      </a>
      <DropdownMenuTrigger>
        <ChevronDown class="size-4" />
      </DropdownMenuTrigger>
    </div>
    <DropdownMenuTrigger v-else class="flex whitespace-nowrap font-normal sm:font-medium sm:text-sm items-center hover:underline cursor-pointer">
      <Component v-if="iconComponent" :is="iconComponent" class="size-4 mr-1" />
      {{ name }}
      <ChevronDown class="size-4" />
    </DropdownMenuTrigger>

    <DropdownMenuContent class="bg-white">
      <RecursiveDropdown :items="computedItems" />
    </DropdownMenuContent>
  </DropdownMenu>
</template>
